import React, { useState, useRef, useEffect } from "react";
import PersonIcon from "@mui/icons-material/Person";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AlertModal from "../common/AlerModel";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

const Header = ({ activeUser, clientmenu, setLoading }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isArrowDown, setIsArrowDown] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
  });

  const Signout = async () => {
    console.log("rrrrrrrrrr");
    setLoading(true);
    try {
      await Auth.signOut();

      localStorage.clear();
      navigate("/");
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    setModal({
      show: true,
      type: "warning",
      title: "Are you sure?",
      message: "Do you want to Sign Out?",
      isConfirm: true,
      onConfirm: confirmLogout,
      onCancel: () => setModal((prev) => ({ ...prev, show: false })),
    });
  };

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const confirmLogout = () => {
    setModal((prev) => ({ ...prev, show: false }));
    setModal({
      show: true,
      type: "success",
      title: "Success!",
      message: "Signed out successfully.",
      autoClose: false,
      nextAction: () => {
        Signout();
      },
    });
  };

  const toggleDropdown = () => {
    setIsDropdownVisible((prev) => !prev);
    setIsArrowDown((prev) => !prev);
  };
  const clientnav = () => {
    navigate("/my-clients");
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
        setIsArrowDown(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="header2">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <header>
        <div className="header-cus">
          <img
            src="/images/logo.png"
            alt="Grains Global Logo"
            className="logo"
          />
        </div>
        <div className="diplay-flex-css1">
          <nav>
            <ul>
              <li ref={dropdownRef} className="profile-menu">
                <div onClick={toggleDropdown} className="profile-trigger">
                  <PersonIcon />

                  {activeUser}
                  {isArrowDown ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </div>
                {isDropdownVisible && (
                  <div className="profile-dropdown">
                    <div className="dropdown-content">
                      {clientmenu ? (
                        <>
                          <button onClick={clientnav} className="dropdown-item">
                            <PersonIcon /> My Client
                          </button>{" "}
                          <div className="border-1"></div>
                        </>
                      ) : (
                        ""
                      )}

                      <button onClick={handleSubmit} className="dropdown-item">
                        <ExitToAppIcon /> Sign Out
                      </button>
                    </div>
                  </div>
                )}
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
